import { Record } from 'immutable';
import CustomReminderEmail from 'MeetingsBase/models/CustomReminderEmail';
import CustomConfirmationEmail from 'MeetingsBase/models/CustomConfirmationEmail';
const defaults = {
  customReminderEmail: new CustomReminderEmail(),
  customConfirmationEmail: new CustomConfirmationEmail()
};
export default class LinkAssociatedSetting extends Record(defaults) {
  static from(json) {
    const customReminderEmail = CustomReminderEmail.from(json.customReminderEmail);
    const customConfirmationEmail = CustomConfirmationEmail.from(json.customConfirmationEmail);
    return new LinkAssociatedSetting({
      customReminderEmail,
      customConfirmationEmail
    });
  }
  convertToJSON() {
    const output = {
      customReminderEmail: this.get('customReminderEmail').toJSON(),
      customConfirmationEmail: this.get('customConfirmationEmail').toJSON()
    };
    return output;
  }

  /**
   * Use convertToJSON
   * @deprecated
   */
  toJS() {
    return super.toJS();
  }

  /**
   * Use convertToJSON
   * @deprecated
   */
  toJSON() {
    return super.toJSON();
  }
}